import Translations from '@helpers/translations'
import {
  useForm,
  FormProvider,
  SubmitHandler,
  useFormState
} from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { InputField } from '../../../ui/formElements/form/InputField'

type EmailFormProps = {
  onSubmit: (email: string) => void
  children: (name: string, isValid: boolean) => React.ReactNode
  classes?: string | undefined
  placeholder?: string
}

const emailSchema = z.object({
  newsletter: InputField.getSchema('email', true)
})

type EmailFormData = z.infer<typeof emailSchema>

export function EmailForm({
  onSubmit,
  classes,
  placeholder,
  children
}: EmailFormProps) {
  const methods = useForm<EmailFormData>({
    resolver: zodResolver(emailSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: { newsletter: '' }
  })

  const { handleSubmit, watch, control } = methods
  const { isValid } = useFormState({ control })
  const email = watch('newsletter')

  const submitHandler: SubmitHandler<EmailFormData> = data => {
    onSubmit(data.newsletter)
  }

  return (
    <FormProvider {...methods}>
      <form
        method="post"
        className={classes}
        onSubmit={handleSubmit(submitHandler)}
        noValidate
      >
        <InputField<EmailFormData>
          placeholder={
            placeholder ||
            Translations.localise(
              'common.newsletter-modal.form.email-placeholder'
            )
          }
          name="newsletter"
          type="email"
          required
          label="Email"
        />
        {children(email, isValid)}
      </form>
    </FormProvider>
  )
}
